import { useState, useEffect, useRef, useContext } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./LanguageDropdown.css";
import { LanguageContext } from "../../context/LanguageContext";

const languages = [
  { code: 'EN', name: 'English', flag: 'us' },
  { code: 'IN', name: 'हिन्दी', flag: 'in' }
  /*{ code: 'FR', name: 'Français', flag: 'fr' },
  { code: 'ES', name: 'Español', flag: 'es' },
  { code: 'DE', name: 'Deutsch', flag: 'de' },
  { code: 'IT', name: 'Italiano', flag: 'it' },
  { code: 'RU', name: 'Русский', flag: 'ru' },
  { code: 'PL', name: 'Polski', flag: 'pl' },
  { code: 'NL', name: 'Nederlands', flag: 'nl' },
  { code: 'RO', name: 'Română', flag: 'ro' },
  { code: 'CS', name: 'Čeština', flag: 'cz' },
  { code: 'PT', name: 'Português PT', flag: 'pt' },
  { code: 'AR', name: 'العربية', flag: 'sa' },*/
];

const langMap = {
  EN: "en",
  IN: "hi"
};

const reverseLangMap = {
  en: "EN",
  hi: "IN"
};

const LanguageDropdown = () => {
  const dropdownRef = useRef(null);
  const [open, setOpen] = useState(false);

  const { selectedLanguage, setSelectedLanguage } =
    useContext(LanguageContext);

  // UI selected language (object)
  const [selected, setSelected] = useState(languages[0]);

  // 🔹 Load saved language on mount
  useEffect(() => {
    const savedLangCode = localStorage.getItem("preferredLang"); // EN / IN

    if (savedLangCode && langMap[savedLangCode]) {
      const uiLang = languages.find(
        (lang) => lang.code === savedLangCode
      );

      if (uiLang) {
        setSelected(uiLang);
        setSelectedLanguage(langMap[savedLangCode]); // en / hi
      }
    }
  }, [setSelectedLanguage]);

  // 🔹 Sync dropdown UI when language changes elsewhere
  useEffect(() => {
    const uiCode = reverseLangMap[selectedLanguage];
    const uiLang = languages.find((l) => l.code === uiCode);
    if (uiLang) setSelected(uiLang);
  }, [selectedLanguage]);

  // 🔹 Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleSelect = (lang) => {
    setSelected(lang);
    setOpen(false);

    localStorage.setItem("preferredLang", lang.code); // EN / IN
    setSelectedLanguage(langMap[lang.code]); // en / hi
  };

  return (
    <div className="language-selector" ref={dropdownRef}>
      <div className={`selector ${open ? "open" : ""}`} onClick={toggleDropdown}>
  <img
    src={`/assets/flags/${selected.flag}.png`}
    alt={selected.name}
    className="flag-icon"
  />
  <span>{selected.name}</span>
  <FaChevronDown className="dropdown-icon" />
</div>

      {open && (
        <div className="dropdown-menu">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className="dropdown-item"
              onClick={() => handleSelect(lang)}
            >
              <img
                src={`/assets/flags/${lang.flag}.png`}
                alt={lang.name}
                className="flag-icon"
              />
              <span>
                {lang.name} - {lang.code}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;

